import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private readonly logs: string[] = [];

  log(msg: any, saveOnly = false): void {
    this.logWithLevel(LogLevel.info, msg, saveOnly);
  }

  warning(msg: any, saveOnly = false): void {
    this.logWithLevel(LogLevel.warning, msg, saveOnly);
  }

  error(msg: any, saveOnly = false): void {
    this.logWithLevel(LogLevel.error, msg, saveOnly);
  }

  get allLogs(): string {
    return this.logs.join('\n');
  }

  private logWithLevel(level: LogLevel, msg: any, saveOnly: boolean): void {
    let msgString: string = JSON.stringify(msg);
    msgString = msgString.replace(/\\n|\\t/g, '').replaceAll(/\s+/g, ' ');
    const date = new Date().toLocaleString();
    this.logs.push(`${date} - ${msgString}`);
    if (saveOnly) {
      return;
    }

    switch (level) {
      case LogLevel.info:
        console.log(msg);
        break;
      case LogLevel.warning:
        console.warn(msg);
        break;
      case LogLevel.error:
        console.error(msg);
        break;
    }
  }
}

enum LogLevel {
  info,
  warning,
  error
}
